import { Box, Typography } from "@mui/material";
import { DARK_SURFACES } from "@/shared/theme";

export const ControlTourCopy = ({ title, body }: { title: string; body: string }) => (
  <Box sx={{ color: DARK_SURFACES.canvas, textAlign: "left" }}>
    <Typography component="h2" sx={{ fontSize: "1.1rem", fontWeight: 900, lineHeight: 1.2, mb: 1 }}>
      {title}
    </Typography>
    <Typography sx={{ fontSize: ".85rem", lineHeight: 1.55 }}>{body}</Typography>
  </Box>
);
